import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Meta from 'vue-meta'
import i18n from '@/i18n'
import VueScrollTo from 'vue-scrollto'
import VueMq from 'vue-mq'
import Simplert from 'vue2-simplert-plugin'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import VueAnalytics from 'vue-analytics'
import VueCookie from 'vue-cookie'

import 'nprogress/nprogress.css'
require('vue2-simplert-plugin/dist/vue2-simplert-plugin.css')

const moment = require('moment')
require('moment/locale/es')
require('moment/locale/ca')
const NProgress = require('nprogress')
/* const breakpoints = {
  mobile: 320,
  tablet: 768,
  desktop: 1024,
  widescreen: 1216,
  fullhd: 1920
} */
const breakpoints = {
  mobile: 768,
  tablet: 1024,
  desktop: 1216,
  widescreen: 1408,
  fullhd: 1920
}
const SnotifyOptions = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}
Vue.use(VueScrollTo)
Vue.use(Meta)
Vue.use(Simplert, {
  customConfirmBtnClass: 'button is-uppercase',
  customCloseBtnClass: 'button is-uppercase is-info'
})
Vue.use(require('vue-moment'), {
  moment
})
Vue.use(VueMq, {
  breakpoints
})
Vue.use(Snotify, SnotifyOptions)
Vue.use(VueAnalytics, {
  id: 'UA-129818643-5',
  router,
  ignoreRoutes: ['/dashboard'],
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  },
  autoTracking: {
    screenview: true
  }
})
Vue.use(VueCookie)

axios.interceptors.request.use(
  function (config) {
    const token = sessionStorage.getItem('token')
    if (process.env.VUE_APP_OAUTH_TOKEN_URL === config.url) {
      return config
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  function (err) {
    return Promise.reject(err)
  }
)
axios.interceptors.response.use(
  function (response) {
    if (response.data.error) {
      if (response.data.error === 'invalid_grant') {
        // store.dispatch('logout')
      }
    }
    return response
  },
  function (err) {
    if (err.response.status === 401) {
      // store.dispatch('logout')
      // router.push('/')
    }
    return Promise.reject(err)
  }
)
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

Vue.config.productionTip = false

router.beforeResolve((to, from, next) => {
  if (to.path) {
    NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})
i18n.locale = store.getters.activeLanguage
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  renderError (h, err) {
    return h('pre', { style: { color: 'red' } }, err.stack)
  }
}).$mount('#app')
